import {Alert, Button, Form, Row} from "react-bootstrap";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  getPlayerProfile,
  reactivatePlayer,
  setBirthday,
  setFirstName,
  setLastName,
  setZipcode
} from "../actions/backOfficeAction";
import InputMask from "react-input-mask";

const PlayerProfileDetails = ({playerProfile}) => {

  const dispatch = useDispatch();

  const [editingBirthday, setEditingBirthday] = useState(false);
  const [newBirthday, setNewBirthday] = useState(playerProfile?.dob);
  const [editingZipcode, setEditingZipcode] = useState(false);
  const [newZipcode, setNewZipcode] = useState(playerProfile?.zipcode);
  const [editingFirstName, setEditingFirstName] = useState(false);
  const [newFirstName, setNewFirstName] = useState(playerProfile?.firstName);
  const [editingLastName, setEditingLastName] = useState(false);
  const [newLastName, setNewLastName] = useState(playerProfile?.lastName);

  const reactivatePlayerProcessing = useSelector(
    (state) => state.backOfficeState.reactivatePlayerProcessing
  );
  const reactivatePlayerResult = useSelector(
    (state) => state.backOfficeState.reactivatePlayerResult
  );
  const reactivatePlayerError = useSelector(
    (state) => state.backOfficeState.reactivatePlayerError
  );

  // errors from profile actions used in this component
  const setBirthdayError = useSelector((state) => state.backOfficeState.setBirthdayError);
  const setZipcodeError = useSelector((state) => state.backOfficeState.setZipcodeError);
  const setFirstNameError = useSelector((state) => state.backOfficeState.setFirstNameError);
  const setLastNameError = useSelector((state) => state.backOfficeState.setLastNameError);

  // helper to convert various error shapes to readable strings
  const formatError = (err) => {
    if (!err) return null;
    if (typeof err === "string") return err;
    if (Array.isArray(err)) return err.map((e) => (typeof e === "string" ? e : JSON.stringify(e))).join("; ");
    if (err.message) return err.message;
    try {
      return JSON.stringify(err);
    } catch (e) {
      return String(err);
    }
  };

  const combinedErrors = [
    reactivatePlayerError,
    setBirthdayError,
    setZipcodeError,
    setFirstNameError,
    setLastNameError,
  ].map(formatError).filter(Boolean);

  async function reactivateClickedHandler(rewardsId) {
    await dispatch(reactivatePlayer(rewardsId));
    dispatch(getPlayerProfile(rewardsId));
  }

  // Called when the edit birthday button is clicked
  function editBirthdayClickedHandler() {
    // Set the value of the newBirthday state to the current birthday to start with
    setNewBirthday(playerProfile?.dob ?? '');
    // Set the editingBirthday state to true to show the editing form
    setEditingBirthday(true);
  }

  // Called when the save button is clicked after editing the birthday
  function saveBirthdayHandler() {
    setEditingBirthday(false);
    dispatch(setBirthday(playerProfile?.guestId, newBirthday));
  }

  // Called when the cancel button is clicked after editing the birthday
  function cancelBirthdayHandler() {
    setEditingBirthday(false);
  }

  // Called when the edit zipcode button is clicked
  function editZipcodeClickedHandler() {
    // Set the value of the newZipcode state to the current zipcode to start with
    setNewZipcode(playerProfile?.zipcode ?? '');
    // Set the editingZipcode state to true to show the editing form
    setEditingZipcode(true);
  }

  // Called when the save button is clicked after editing the zip code
  function saveZipcodeHandler() {
    setEditingZipcode(false);
    dispatch(setZipcode(playerProfile?.guestId, newZipcode));
  }

  // Called when the cancel button is clicked after editing the zip code
  function cancelZipcodeHandler() {
    setEditingZipcode(false);
  }

  function editFirstNameClickedHandler() {
    setNewFirstName(playerProfile?.firstName ?? '');
    setEditingFirstName(true);
  }

  async function saveFirstNameHandler() {
    try {
      await dispatch(setFirstName(playerProfile?.guestId, newFirstName));
      dispatch(getPlayerProfile(playerProfile?.guestId));
    } finally {
      setEditingFirstName(false);
    }
  }
  function cancelFirstNameHandler() { setEditingFirstName(false); }

  function editLastNameClickedHandler() {
    setNewLastName(playerProfile?.lastName ?? '');
    setEditingLastName(true);
  }

  async function saveLastNameHandler() {
    try {
      await dispatch(setLastName(playerProfile?.guestId, newLastName));
      dispatch(getPlayerProfile(playerProfile?.guestId));
    } finally {
      setEditingLastName(false);
    }
  }
  function cancelLastNameHandler() { setEditingLastName(false); }

  return (
    <div className="admin-screen-divider-div player-profile-details">
      <h4 className="player-profile-details-header">
        Guest User<br />
        {playerProfile?.firstName} {playerProfile?.lastName}, Player ID: {playerProfile?.guestId}
      </h4>
      <div className="player-profile-details">
        <div className="edit-in-place-form-field">
          {editingBirthday ? (
            <>
              <Form.Group as={Row} controlId="formBasicPassword">
                <Form.Label className="gcotg-form-label">
                  Birthday(MM/DD/YYYY)
                </Form.Label>
                <Form.Control
                  as={InputMask}
                  mask="99/99/9999"
                  placeholder="mm/dd/yyyy"
                  value={newBirthday || ''}
                  onChange={(e) => setNewBirthday(e.target.value)}
                  className="form-control gcotg-form-element"
                />
              </Form.Group>
              <Button
                variant="primary"
                size="sm"
                className="in-place-form-button-secondary"
                onClick={() => cancelBirthdayHandler()}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                size="sm"
                className="in-place-form-button-primary"
                onClick={() => saveBirthdayHandler()}
              >
                Save New Birthday
              </Button>
            </>
          ) : (
            <span className="player-profile-details-non-edit-container">
              <span>Birthday: {playerProfile?.dob}</span>
              <Button variant="primary" size="sm" className="gcotg-button"
                onClick={editBirthdayClickedHandler}>
                Edit Birthday
              </Button>
            </span>
          )}
        </div>

        {playerProfile?.zipcode && (
          <div className="edit-in-place-form-field">
            {editingZipcode ? (
              <>
                <Form.Group as={Row} controlId="formBasicPassword">
                  <Form.Label className="gcotg-form-label">ZIP Code</Form.Label>
                  <Form.Control
                    placeholder="ZIP Code"
                    value={newZipcode || ''}
                    onChange={(e) => setNewZipcode(e.target.value)}
                    className="form-control gcotg-form-element login-zipcode-form-element"
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  size="sm"
                  className="in-place-form-button-secondary"
                  onClick={() => cancelZipcodeHandler()}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  className="in-place-form-button-primary"
                  onClick={() => saveZipcodeHandler()}
                >
                  Save New ZIP code
                </Button>
              </>
            ) : (
              <span className="player-profile-details-non-edit-container">
                <span>ZIP code: {playerProfile?.zipcode}</span>
                <Button
                  variant="primary"
                  size="sm"
                  className="gcotg-button"
                  onClick={() => editZipcodeClickedHandler()}
                >
                Edit ZIP code
                </Button>
              </span>
            )}
          </div>
        )}

        {/* First name edit-in-place */}
        <div className="edit-in-place-form-field">
          {editingFirstName ? (
            <>
              <Form.Group as={Row} controlId="editFirstName">
                <Form.Label className="gcotg-form-label">First Name</Form.Label>
                <Form.Control
                  placeholder="First Name"
                  value={newFirstName || ''}
                  onChange={(e) => setNewFirstName(e.target.value)}
                  className="form-control gcotg-form-element"
                />
              </Form.Group>
              <Button variant="primary" size="sm" className="in-place-form-button-secondary"
                      onClick={cancelFirstNameHandler}>Cancel</Button>
              <Button variant="primary" size="sm" className="in-place-form-button-primary"
                      onClick={saveFirstNameHandler}>Save New First Name</Button>
            </>
          ) : (
            <span className="player-profile-details-non-edit-container">
              <span>First Name: {playerProfile?.firstName}</span>
              <Button variant="primary" size="sm" className="gcotg-button"
                      onClick={editFirstNameClickedHandler}>Edit First Name</Button>
            </span>
          )}
        </div>

        {/* Last name edit-in-place */}
        <div className="edit-in-place-form-field">
          {editingLastName ? (
            <>
              <Form.Group as={Row} controlId="editLastName">
                <Form.Label className="gcotg-form-label">Last Name</Form.Label>
                <Form.Control
                  placeholder="Last Name"
                  value={newLastName || ''}
                  onChange={(e) => setNewLastName(e.target.value)}
                  className="form-control gcotg-form-element"
                />
              </Form.Group>
              <Button variant="primary" size="sm" className="in-place-form-button-secondary"
                      onClick={cancelLastNameHandler}>Cancel</Button>
              <Button variant="primary" size="sm" className="in-place-form-button-primary"
                      onClick={saveLastNameHandler}>Save New Last Name</Button>
            </>
          ) : (
            <span className="player-profile-details-non-edit-container">
              <span>Last Name: {playerProfile?.lastName}</span>
              <Button variant="primary" size="sm" className="gcotg-button"
                      onClick={editLastNameClickedHandler}>Edit Last Name</Button>
            </span>
          )}
        </div>

        {playerProfile?.disabled &&
          <Alert variant='warning'>
            {playerProfile?.disabled ? "LOGIN DISABLED" : ""}
            <span className="reactivate-button-span">
                <Button variant="primary" size="sm" className="gcotg-button"
                        onClick={() => reactivateClickedHandler(playerProfile?.guestId)}
                        disabled={reactivatePlayerProcessing ? true : undefined}>
                Reactivate
                </Button>
              </span>
          </Alert>
        }

        {/* Combined server error messages for actions in this component */}
        {combinedErrors.length > 0 && (
          <Alert variant="danger" className="gcotg-error-message" style={{marginTop:12}}>
            {combinedErrors.map((errMsg, idx) => (
              <div key={idx}>{errMsg}</div>
            ))}
          </Alert>
        )}
      </div>
    </div>
  );
}

export default PlayerProfileDetails;

